import React, { useEffect, useState } from 'react';
import BreadCrumb from "../../components/breadcrumb/BreadCrumb";
import styles from "./detailedview.module.scss";
import * as utils from "../../utils/utils";
import { Spin } from 'antd';
import * as consts from '../../utils/constant';
import * as favUtils from '../../utils/favorite.utils';
import Attributes from '../attributes/strategicAccount'
import * as constants from "../../../src/utils/constant";
import * as nbaurls from "../../../src/utils/nba.utils"
import KPIScore from './Tiles/Redesign/KPIScore';
import CXScore from './Tiles/Redesign/CXScore';
import { CreateScoreLinks } from '../score/Score.utils';
import CustCAS from './Tiles/Redesign/CustCAS';

const StrategicAccounts = (props) => {
    console.log("Strategic Accounts -- Detail Page", props)
    const favInput = JSON.parse(JSON.stringify(props.favInput));
    const { selectedStrategicAccount } = props;
    console.log("Selected StrategicAccounts Name in Detailed View page", selectedStrategicAccount);
    let [FavoriteId, setFavoriteId] = useState(null)
    const [loading, setLoading] = useState(false)
    const [region, setRegion] = useState(JSON.parse(sessionStorage.getItem("selectedRegion")));//EMEA Release- 
    const primaryRecommendation = (selectedStrategicAccount && selectedStrategicAccount.primaryRecommendation && selectedStrategicAccount.primaryRecommendation.length>0)?  Array.isArray(selectedStrategicAccount.primaryRecommendation) ? selectedStrategicAccount.primaryRecommendation[0].toLocaleLowerCase() : selectedStrategicAccount.primaryRecommendation.toLocaleLowerCase():"";//EMEA Release- for fixing Favorite Prod issue
    const secondaryRecommendations = (selectedStrategicAccount && selectedStrategicAccount.secondaryRecommendations) ? selectedStrategicAccount.secondaryRecommendations : [];
    const [isattrSectionLoaded, setIsAttrSectionLoaded] = useState(false);
    const [strategicAccountDetails, setStrategicAccountDetails] = useState(null);
    const [KPI, setKPI] = useState(null)
    const [cxScr, setCxScore] = useState(null)
    let level = 'strategicaccounts'
    const breadcrumbList = [
        {
            value: `Dashboard (${region})`,
            path: "/dashboard",
        }
    ];

   breadcrumbList.push({ value: `${utils.capitalize('Strategic Accounts')} (${region})`, path: '/' });

   const createBreadCrumb = () => {
    breadcrumbList[breadcrumbList.length - 1].path = '/dashboard/strategicaccountsdetail'
    return breadcrumbList;
   }

   //Elastic Search Format Data - Strategi Account
    const formatData = (result) => {
        let strategicAccount = {}
        const hitsArray = (result && result.hits && result.hits.hits && result.hits.hits.length > 0) ? result.hits.hits[0] : [];
		strategicAccount = (hitsArray && hitsArray['_source']) ? hitsArray['_source'].group.filter(item => (item.company_region.toLowerCase() === region.toLowerCase()))[0] : {};
        return strategicAccount;
    }

    useEffect(() => {
        const input = {
            name: constants.StrategicAccounts_ScoreDetails_Index,
            queryParams: {
                "query": {
                    "match_all": {}
                }
            }
        }
        setLoading(true)
        utils.getDataES('-elasticsearch', 'POST', input)
            .then(resp => {

                let ESData = formatData(resp.data);

                console.log("Strategic Account ES Data Formatted Response", ESData);

                if (Object.keys(ESData).length > 0) {
                    const { company_region } = ESData;
                    //kpiHandler(ESData, KpiScoreTrends, cxList);
                    setRegion(company_region)
                }else {
                setRegion(JSON.parse(sessionStorage.getItem("selectedRegion")))
                }
                setStrategicAccountDetails(ESData)
                props.setKPI({})
                props.setCXScoreData(ESData);//added kpiToPB
                //setData(JSON.parse(JSON.stringify(result)))
                setLoading(false)
            }).catch(err => setLoading(false))
    }, [props.selectedStrategicAccount])

    //cxList, cxScore and CAS
    let cxScore, cas, cxList, cxListDP, cxKeys, cxValues, cxScoreTrend;
    const getSortedCXList = (cxList) => {
        if (cxList) {
            let list = [...cxList]
            list.forEach(element => {
                element.difference = element.score - element.lastQuarterValue
                element.differenceCent = ((element.score - element.lastQuarterValue) / (element.lastQuarterValue)) * 100
            });

            return list.sort(utils.sorting('differenceCent', 'number', false))
        }
        return cxList
    }

    if (strategicAccountDetails && Object.keys(strategicAccountDetails).length > 0) {

        cxScore = strategicAccountDetails.cxScore;
        if (strategicAccountDetails && strategicAccountDetails.cxList && strategicAccountDetails.cxList.length > 0) {
            cxListDP = strategicAccountDetails.cxList.find(item => item.name.toLowerCase() === consts.HELD_ORDER_INDEX.toLowerCase());
            console.log("cxListDP--",cxListDP);
            //Held Order Index Data Points is used for CXScore Data Points
            cxScore.dataPoints = (cxListDP && cxListDP.dataPoints) ? cxListDP.dataPoints : '';
            
        }
        cas = strategicAccountDetails.cas;
        cxList = getSortedCXList(strategicAccountDetails.cxList);
    }
    else {
        //strategicAccountDetails={};
        cxScore = {};
        cas = {};
        cxList = [{ score: 0 }];
    }
    //View Score contains score details of  KPI/ CAS score / cxScore
    const viewScore = (score, item) => {
        if (strategicAccountDetails && Object.keys(strategicAccountDetails).length > 0) {
            // props.setCXScoreData(strategicAccountDetails);
            props.setBreadCrumb(createBreadCrumb());
            if (score === 'cas') {
                props.setKPI();
                props.setSASParent('cas');
                props.history.push("/dashboard/score/cas");
            } else if (score === 'cx') {
                props.setKPI();
                props.setSASParent('cx');
                props.history.push("/dashboard/score");
            }
            else {
                console.log("My KPI Item is", item)
                props.setSASParent('kpi');
                props.setKPI(item);
                //props.setBannerType(item.name.toLowerCase().replace(/\s+/g, ''));
                props.history.push("/dashboard/primaryview");
            }
        }
    };

    const getInsights = (nba) => {
        if (strategicAccountDetails.nba_insights) {
            let insights = strategicAccountDetails.nba_insights.filter(element => element.metrics_name.toLowerCase() === nba.toLowerCase())
            if (insights && insights.length) {
                return insights[0].insights
            }
            return []
        }
        return []
    }

    const primaryView = (nba) => {
        let _nba = ''
        const urls = nbaurls.sa_nba_urls(nba, region);
        switch (nba) {
            case consts.IMPROVE_INVOICE_AGING:
                _nba = {
                    name: nba,
                    primaryView: urls.primaryView,
                    childView: urls.childView,
                    historyView: urls.historyView,
                    insights: getInsights(consts.IMPROVE_INVOICE_AGING)
                }
                props.setNBA(_nba);
                props.setBannerType(consts.IMPROVE_INVOICE_AGING.replace(/\s+/g, ''));
                break;
            case consts.REDUCE_RETURN_PERCENTAGE:
                _nba = {
                    name: nba,
                    primaryView: urls.primaryView,
                    childView: urls.childView,
                    historyView: urls.historyView,
                    insights: getInsights(consts.REDUCE_RETURN_PERCENTAGE)
                }
                props.setNBA(_nba);
                props.setBannerType(consts.REDUCE_RETURN_PERCENTAGE.replace(/\s+/g, ''));
                break;
            case consts.IMPROVE_PRODUCT_AVAILABILITY:
                _nba = {
                    name: nba,
                    primaryView: urls.primaryView,
                    childView: urls.childView,
                    historyView: urls.historyView,
                    insights: getInsights(consts.IMPROVE_PRODUCT_AVAILABILITY)
                }
                props.setNBA(_nba);
                props.setBannerType(consts.IMPROVE_PRODUCT_AVAILABILITY.replace(/\s+/g, ''));
                break;
            case consts.NEW_IMPROVE_ORDER_VELOCITY:
                _nba = {
                    name: nba,
                    primaryView: urls.primaryView,
                    childView: urls.childView,
                    historyView: urls.historyView,
                    insights: getInsights(consts.NEW_IMPROVE_ORDER_VELOCITY)
                }
                props.setNBA(_nba);
                props.setBannerType(consts.NEW_IMPROVE_ORDER_VELOCITY.replace(/\s+/g, ''));
                break;
            case consts.IMPROVE_OTIF:
                _nba = {
                    name: nba,
                    primaryView: urls.primaryView,
                    childView: urls.childView,
                    historyView: urls.historyView,
                    insights: getInsights(consts.IMPROVE_OTIF)
                }
                props.setNBA(_nba);
                props.setBannerType(consts.IMPROVE_OTIF.replace(/\s+/g, ''));
                break;
            case consts.INCREASE_CREDITLINE:
                _nba = {
                    name: nba,
                    primaryView: urls.primaryView,
                    childView: urls.childView,
                    historyView: urls.historyView,
                    insights: getInsights(consts.INCREASE_CREDITLINE)
                }
                props.setNBA(_nba);
                props.setBannerType(consts.INCREASE_CREDITLINE.replace(/\s+/g, ''));
                break;
            default:
                break;
        }

        props.setNBABreadCrumb(createBreadCrumb())
        props.history.push('/dashboard/nba/primaryview')
    }

    //Favorites Code
    async function getFavorites() {
        const favorites = await favUtils.getFavorites()
        props.setFavorite(favorites)
    }

    async function addToFavorite(isAlreadyFavorite) {
        try {
            setLoading(true)
            if (!isAlreadyFavorite) {
                console.log("Strategic Account--Detail Page --seelected Strategic acct", selectedStrategicAccount)
                favInput.UserId = utils.getUserEmail()
                favInput.ViewType = 1;
                favInput.region = region; //Added for EMEA release
                favInput.InputParameters.strategicAccts = selectedStrategicAccount;
                if (selectedStrategicAccount) {
                    favInput.InputParameters.group.company_region = favInput.InputParameters.strategicAccts.company_region; //added for EMEA release
                }
                console.log("Strategic Account--Detail Page --favInput", favInput)
                const FavoriteId = await favUtils.addFavorites(favInput)
                console.log("Strategic Account--Detail Page --FavoriteId", FavoriteId)
                setFavoriteId(FavoriteId)
            } else {
                await favUtils.removeFavorites(FavoriteId)
                setFavoriteId(null)
            }
            setLoading(false)
            getFavorites()
        } catch (err) {
            console.log(err);
            setLoading(false)
        }
    }

    useEffect(() => {
        setFavoriteId(favUtils.chkIsFavorite(
            props.favorites,
            region, //added for EMEA release
            1,
            props.selectedProductDivision,
            {},
            {},
            '',
            '',
            {},
            selectedStrategicAccount))
    }, [selectedStrategicAccount])

    //added kpiToPB
    useEffect(() => {
        if (props.cxScoreDetails && strategicAccountDetails) {
            console.log("strategicAccountDetails.js UseEffect--props", props);
            const navList = CreateScoreLinks(props, false); 
            console.log("CreateScoreLinks In UseEffect--strategicAccountDetails.js", navList, strategicAccountDetails)
            const { KpiScoreTrends, cxList } = strategicAccountDetails;
            kpiHandler(strategicAccountDetails, KpiScoreTrends, cxList, navList);
        }
    }, [props.cxScoreDetails,strategicAccountDetails]) // 

    const nbas = [
        {
            nba: consts.NEW_IMPROVE_ORDER_VELOCITY,
            primaryRecommendation: primaryRecommendation === consts.NEW_IMPROVE_ORDER_VELOCITY.toLowerCase() ? true : false,
            isOutlineRequired: utils.getRecommendationFlag(secondaryRecommendations, consts.NEW_IMPROVE_ORDER_VELOCITY)
        },
        {
            nba: consts.INCREASE_CREDITLINE,
            primaryRecommendation: primaryRecommendation === consts.INCREASE_CREDITLINE.toLowerCase() ? true : false,
            isOutlineRequired: utils.getRecommendationFlag(secondaryRecommendations, consts.INCREASE_CREDITLINE)
        },

        {
            nba: consts.IMPROVE_INVOICE_AGING,
            primaryRecommendation: primaryRecommendation === consts.IMPROVE_INVOICE_AGING.toLowerCase() ? true : false,
            isOutlineRequired: utils.getRecommendationFlag(secondaryRecommendations, consts.IMPROVE_INVOICE_AGING)
        },
        {
            nba: consts.IMPROVE_PRODUCT_AVAILABILITY,
            primaryRecommendation: primaryRecommendation === consts.IMPROVE_PRODUCT_AVAILABILITY.toLowerCase() ? true : false,
            isOutlineRequired: utils.getRecommendationFlag(secondaryRecommendations, consts.IMPROVE_PRODUCT_AVAILABILITY)
        },
        {
            nba: consts.IMPROVE_OTIF,
            primaryRecommendation: primaryRecommendation === consts.IMPROVE_OTIF.toLowerCase() ? true : false,
            isOutlineRequired: utils.getRecommendationFlag(secondaryRecommendations, consts.IMPROVE_OTIF)
        },
        {
            nba: consts.REDUCE_RETURN_PERCENTAGE,
            primaryRecommendation: primaryRecommendation === consts.REDUCE_RETURN_PERCENTAGE.toLowerCase() ? true : false,
            isOutlineRequired: utils.getRecommendationFlag(secondaryRecommendations, consts.REDUCE_RETURN_PERCENTAGE)
        }
    ]

    const kpiHandler = (strategicAccounts, KpiScoreTrends, cxList, navList) => {
        let kpiSortedList, newKpiList;

        kpiSortedList = getSortedCXList(cxList); 
        
        newKpiList = kpiSortedList.map((item) => {
            let newKPIMergedObj, kpiName, navItm;
            kpiName = item.name.split(" ").join("").toLowerCase(); 
            navItm = navList?.find((item => item.name.split(" ").join("").toLowerCase() === kpiName));

            let { primary, child, history } = navItm;
            for (const [key, value] of Object.entries(KpiScoreTrends)) {
                console.log(`My KPI ${key}: ${value}`);
                let kpiName_scoreTrend = key.split(" ").join("").toLowerCase();
                if (kpiName === kpiName_scoreTrend) {//compare cxList KPI name and kpiScoretrend kpi name 
                    let keys, values;
                    keys = value.quarterly.map(key => key.period_value);
                    values = handleKPIChartValues(value, kpiName); console.log("MY KPI Score trend Keys-----", keys); console.log("My KPI Score trend Values-----", values);

                    newKPIMergedObj = { ...item, ...value, kpiKeys: keys, kpiValues: values, primary, child, history }; console.log("My KPI newKPIMergedObj", newKPIMergedObj)
                }
            }
            return newKPIMergedObj
        }); 
        
        setKPI(newKpiList)
        
        cxScoreTrend = strategicAccounts.CXScoreTrend; //Assignment of cxScoreTrend values

        for (const [key, value] of Object.entries(cxScoreTrend)) {
            if (key === "quarterly") {
                cxKeys = cxScoreTrend[key].map(ky => ky.period_value); console.log("cxKeys", cxKeys, value);
                cxValues = handleKPIChartValues(value, "cxScoreTrend"); console.log("cxValues", cxValues);
            }
        }

        let cxObj = { ...cxScore, cxKeys: cxKeys, cxValues: cxValues };
        setCxScore(cxObj) //Assignment of cxScore
    }

    const handleKPIChartValues = (values, kpi) => {
        console.log("My KPI handleKPIChartValues", values, kpi);
        let myChartValueArray, tempScoreVar;
        if (kpi === 'cxScoreTrend') {
            tempScoreVar = 'cxscore';
            myChartValueArray = values.map((item) => item[tempScoreVar] ? item[tempScoreVar].toFixed(0) : "-");
            console.log("My KPI myChartValueArray--1", kpi, " ", myChartValueArray);
        }
        else {
            tempScoreVar = 'score';
            myChartValueArray = values.quarterly.map((item) => item[tempScoreVar] ? item[tempScoreVar].toFixed(0) : "-");
            console.log("My KPI myChartValueArray--2", kpi, " ", myChartValueArray);
        }

        return myChartValueArray;

    }

    const isSectionAttrLoaded = (input) => {
        setIsAttrSectionLoaded(input)
    }

    console.log("Strategic Accounts details", strategicAccountDetails)
    console.log("isattrSectionLoaded", isattrSectionLoaded.toString());

    return (
        <Spin spinning={loading}>
            <div className={styles.cxContainer}>
                <BreadCrumb
                    list={breadcrumbList}
                    {...props}
                    addToFavorite={addToFavorite}
                    isFavorite={FavoriteId ? true : false} />
                <div className="row no-gutters">
                    {strategicAccountDetails && <div className={`${strategicAccountDetails && isattrSectionLoaded ? styles.bgColor : styles.nobgColor} ${styles.rightContent} ${"col-sm-12 col-md-12 col-lg-4"}`}>
                        <Attributes isattrSectionLoaded={isSectionAttrLoaded} code={selectedStrategicAccount.code} divisionCode={props.selectedProductDivision.code} whiteGlove={props.selectedStrategicAccount.whiteGlove} />
                    </div>}
                    <div className={`${styles.leftContent} ${"col-sm-12 col-md-12 col-lg-8"}`} >
                        {
                            strategicAccountDetails ? <React.Fragment>
                                <div className={`${styles.layoutBx} ${"col-sm-12 col-md-12 col-lg-12"}`}>
                                    <h2 className={styles.cxHeading}>Next Best Actions</h2>
                                    <div className={styles.nbaContainer}>
                                        {
                                            nbas.map((element, index) => (
                                                <div
                                                    key={index}
                                                    onClick={() => primaryView(element.nba)}
                                                    className={element.primaryRecommendation ? `${styles.griditem} ${styles.recommended}` :
                                                        element.isOutlineRequired ? `${styles.griditem} ${styles.otherRcmds}` : `${styles.griditem} ${styles.noRcmds} `}
                                                >{element.nba}</div>
                                            ))
                                        }
                                    </div>
                                </div>
                                <div className={`${styles.redesignContainer} ${"col-sm-12 col-md-12 col-lg-12"}`}>

                                    {<div className={`${styles.scoreGridContainer} ${"col-sm-12 col-md-12 col-lg-10"}`}>
                                        <div className={`${styles.scoreGridHeader} ${"col-sm-12 col-md-12 col-lg-12"}`}>
                                            <span>CX Score</span>
                                        </div>

                                        <div className={`${styles.scoreGrid} ${"col-sm-12 col-md-12 col-lg-12"}`}>
                                            {<div className={`${styles.cxScoreContainer}`}>
                                                {cxScore && cxScr && <CXScore cxData={cxScr} cxScore={cxScore} {...props} viewScore={viewScore} />}
                                            </div>}

                                            <div className={`${styles.kpiContainer}`}>
                                                <div className={`${styles.flexContainer}`}>
                                                    {KPI && <KPIScore kpiIndex={3} kpi={KPI}   {...props} viewScore={viewScore} />}
                                                    {KPI && <KPIScore kpiIndex={4} kpi={KPI}   {...props} viewScore={viewScore} />}
                                                    {KPI && <KPIScore kpiIndex={1} kpi={KPI}   {...props} viewScore={viewScore} />}
                                                </div>
                                                <div className={`${styles.flexContainer}`}>
                                                    {KPI && <KPIScore kpiIndex={2} kpi={KPI}  {...props} viewScore={viewScore} />}
                                                    {KPI && <KPIScore kpiIndex={5} kpi={KPI}    {...props} viewScore={viewScore} />}
                                                    {KPI && <KPIScore kpiIndex={6} kpi={KPI}  {...props} viewScore={viewScore} />}
                                                </div>
                                            </div>


                                        </div>
                                    </div>
                                    }
                                    {
                                        <div className={`${styles.casCustContainer}   ${"col-sm-12 col-md-12 col-lg-2"}`}>
                                            <div className={`${styles.casCustHeader}   ${"col-sm-12 col-md-12 col-lg-12"}`}>CAS</div>
                                            {cas && <CustCAS cas={cas} {...props} viewScore={viewScore} type={level} />}
                                        </div>
                                    }
                                </div>
                            </React.Fragment> : null
                        }
                    </div>

                </div>
            </div>
        </Spin>
    );
};

export default StrategicAccounts;


    // if (!utils.isEmpty(props.selectedProductDivision)) {
    //     breadcrumbList.push({ value: `${props.selectedProductDivision.code} (${region})`, path: '/dashboard/productdivision' })
    // }
   // breadcrumbList.push({ value: `${utils.capitalize(selectedStrategicAccount.name)} (${region})`, path: '/' })

           //const type = utils.isEmpty(props.selectedProductDivision) ? 'customer': 'productDivisionCustomer'
        // const type = 'strategicaccounts';
        // //EMEA Release

        // let params = {
        //     "size": 1,
        //     "query": {
        //         "bool": {
        //             "must": [
        //                 {
        //                     "match": {
        //                         "company_region": region
        //                     }
        //                 },
        //                 // {
        //                 //     "match": {
        //                 //         "code": selectedStrategicAccount.code
        //                 //     }
        //                 // }
        //             ]
        //         }
        //     }
        // }
 

        //EMEA Release-
        // let strategicAcctConstant;
        // strategicAcctConstant = 
       // if (type === 'strategicaccounts') {
                
       // }

           //condition check
    // if (utils.isEmpty(props.selectedProductDivision)) {
    //     let item = {
    //         nba: consts.RECURRING_ORDER,
    //         primaryRecommendation: primaryRecommendation === consts.RECURRING_ORDER.toLowerCase() ? true : false,
    //         isOutlineRequired: utils.getRecommendationFlag(secondaryRecommendations, consts.RECURRING_ORDER)
    //     }
    //     nbas.push(item)
    // }
    // console.log("Strategic Format Data--input",result);
        // console.log("Strategic Format Data--input--region",region);
        // const result1 = (result && result.hits && result.hits.hits && result.hits.hits.length > 0) ? result.hits.hits[0] : [];
        // console.log("Strategic Format Data--output",result1);
        // return (result1 && result1['_source']) ? result1['_source'] : {};